
import { Component, Prop, Vue } from 'vue-property-decorator';
import FormGroup from '@/UI/components/common/form/FormGroup.vue';
import moment from 'moment';

import VisitGeneralForm from "@/form/visits/visitGeneral";

import VisitDetailMain from "@/UI/components/forms/visits/detail/VisitDetailMain.vue";
import VisitStatus from "@/UI/components/forms/visits/detail/VisitStatus.vue";
import VisitConumables from "@/UI/components/forms/visits/detail/VisitConsumables.vue";
import VisitPayment    from "@/UI/components/forms/visits/detail/VisitPayment.vue";

@Component({
    components: { FormGroup, VisitDetailMain, VisitStatus, VisitConumables, VisitPayment},
    methods: { moment }
})
export default class VisitDetailModalForm extends Vue {
    @Prop() form!:  VisitGeneralForm;
    current_page: number | 0 = 0;

    changeCurrentPage(id: number) {
        this.current_page = id;
    }
}
